export default __webpack_public_path__ + "static/media/warning.01724af6.svg";